import React, { useEffect, useState } from 'react'
import { AMIL_ICON, QUEUE_AI, QUEUE_FIDYAH_ICON, QUEUE_ZAKAT, QUEUE_ZAKAT_CALC, QUEUE_ZAKAT_ICON } from '../common/images-s3'
import ImageLoader from '../common/image-loader'
import Footer from '../section/footer/footer';
import Header from '../section/header/header';
import { getAppFlow } from '../views/utils/app.utils';
import { APP_FLOW } from '../common/constant';
import * as userAction from '../redux/actions/userAction';
import { useDispatch } from 'react-redux';


export const quickZakatHeader = {
  title: 'Quick Zakat',
  subTitle: 'Next - Enrolment Method',
  steps: 4
}

export const fidyahHeader = {
  title: 'Quick Fidyah',
  subTitle: 'Next - Enrolment Method',
  steps: 4

}

export const zakatCalculatorHeader = {
  title: 'Zakat Calculator',
  subTitle: 'Next - Enrolment Method',
  steps: 4
}

const Options = ({ setHeaderData }) => {
  const [isSkipButtonVisible, setIsSkipButtonVisible] = useState(false);
  const dispatch = useDispatch()
  const [selectedOption, setSelectedOption] = useState({
    name: '',
    id: 0,
    icon: '',
    cardTitle: ''
  })
  const appFlow = getAppFlow()

  const zakatOptions = [{
    name: 'Zakat Contribution',
    id: 1,
    icon: QUEUE_ZAKAT_ICON,
    cardTitle: ''
  },
  {
    name: 'Calculate Zakat with Ai',
    id: 2,
    icon: AMIL_ICON,
    cardTitle: ''
  },
  {
    name: 'Zakat Calculator',
    id: 3,
    icon: QUEUE_ZAKAT_CALC,
    cardTitle: ''
  }

  ]

  const fidyahOptions = [
    {
      name: 'Fidyah Contribution',
      id: 1,
      icon: QUEUE_FIDYAH_ICON,
      cardTitle: ''
    },
    {
      name: 'Fidyah Calculator',
      id: 2,
      icon: QUEUE_ZAKAT_CALC,
      cardTitle: ''
    },
  ]

  const options = appFlow === APP_FLOW.ZAKAT ? zakatOptions : fidyahOptions
  const handleNext = () => {
    const headerData = (appFlow === APP_FLOW.ZAKAT) ?
      (selectedOption.id == 1 ?
        quickZakatHeader :
        zakatCalculatorHeader) :
      fidyahHeader
    dispatch(userAction.updateUserSteps(headerData))
    setHeaderData(headerData)
  }

  const handleSelectedOption = (value) => {
    setSelectedOption(value)
    localStorage.setItem('selectedOption', JSON.stringify(value))  // will store in redux later

  }

  useEffect(() => {
    const selectedOptionType = JSON.parse(localStorage.getItem('selectedOption'))
    if(selectedOptionType)
    {
      setSelectedOption(selectedOptionType)
    }
  }, [])

  const handleSkip = () => {

  }
  return (
    <>
      <div className='flow-view'>
        <div className='cards-block option-pg'>
          {
            options.map((value, index) => {
              return (
                <>
                  <div key={index} className={`common-card card-center ${value?.name === 'Fidyah Calculator' ? "inactive" : ""}  ${selectedOption.id === value.id ? 'active' : ''}`} onClick={() => handleSelectedOption(value)}>
                    <div className='card-left'>
                      <div className='card-icon'>
                        <ImageLoader type="image" src={value.icon}> </ImageLoader>
                      </div>
                      <div className='card-content'>
                        <h4>{value.name}</h4>
                        {value.cardTitle ? <h6>{value.cardTitle}</h6> : null}
                      </div>
                    </div>
                    <div className='card-right custom-radio'>
                      <input type="radio" id={value.id} defaultChecked={selectedOption.id === value.id} checked={selectedOption.id === value.id} />
                    </div>
                  </div>
                </>
              )
            })
          }

        </div>
      </div>
      <Footer isSkipButtonVisible={isSkipButtonVisible} handleNext={handleNext} handleSkip={handleSkip} disabled={!selectedOption.id}/>
    </>
  )
}

export default Options

